"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isApiSlimLandingPageLink = isApiSlimLandingPageLink;
exports.isApiCardLandingPageLink = isApiCardLandingPageLink;
exports.isApiFullLandingPageLink = isApiFullLandingPageLink;
exports.isGroupedProductLink = isGroupedProductLink;
exports.toApiFullLandingPageLink = toApiFullLandingPageLink;
const storefrontParams_1 = require("../storefrontParams");
function isApiSlimLandingPageLink(link) {
    return link.type === storefrontParams_1.EnrichmentMode.SLIM;
}
function isApiCardLandingPageLink(link) {
    return link.type === storefrontParams_1.EnrichmentMode.CARD;
}
function isApiFullLandingPageLink(link) {
    return link.type === storefrontParams_1.EnrichmentMode.FULL;
}
function isGroupedProductLink(link) {
    return link.virtualProductId != null || Boolean(link.productGroupKey);
}
function toApiFullLandingPageLink(link) {
    return link != null && isApiFullLandingPageLink(link) ? link : null;
}
